module.exports = __webpack_public_path__ + "static/media/CJ_Maths_WhyUS.32fef0fb.png";